import { injectIntl } from "react-intl";
import { connect, useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { createSelector } from 'reselect';
import { deleteClaimByContractId } from '../../store/actions/claimAnalysis';
import { deleteReset, getDocumentList, getStates, setContractDependencyDialog, setCopyContractDialog, setStateDialog } from '../../store/actions/contracts';
import { getContractsV2, getHierarchy, resetContracts, setContractsV2DirectoryDependencyDialog, setDirectoryEditDialog, setMoveDialog } from '../../store/actions/contractsv2';
import { list as getFacilities } from "../../store/actions/facilities";
import { set } from '../../store/actions/pages';
import { setV2 } from '../../store/actions/pagesV2';
import { StringEquators } from '../../store/constants/pages';
import { selectContractStates } from "../../store/selectors/contracts";

import { selectSessionRole } from '../../store/selectors/session';
import { createContractStateField, createDateField, createPlainDateField, createStringDataField, createStringFieldFromArrayMapping } from '../../util/format';
import { createFilteredSortedDataSelector } from '../../util/selector';
import { Field } from '../../common/dataTableHeader/DataTableHeader'
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import { RootState } from "../../store/reducers";
import { getEAPGCreditUsage } from "../../store/api/eapg";

const DEFAULT_SORT = [{ id: 'name', orderBy: 'asc', direction: 'asc' }];
const EMPTY_ARRAY: any[] = [];

export const selectContracts = state => state.contractsv2.contracts;
const mockCreditsMessage = "You don't have enough credits to use this feature"

const selectDirectoryId = (state, props) => props.match.params.directoryId;
export const selectFacilityList = (state) => state.facilities.data;

const selectFields = createSelector(
    selectFacilityList,
    selectContractStates,
    (facilitiesArray, contractStates) => [
        createStringDataField('name', 'Contract Name', { sortable: true }),
        createPlainDateField('effectiveDate', 'Effective Date', { fieldType: 'Date' ,sortable: true }),
        createPlainDateField('terminationDate', 'Termination Date', { fieldType: 'Date',sortable: true  }),
        createDateField('finalizedDate', 'Finalized Date', { fieldType: 'Date',sortable: true  }),
        createStringFieldFromArrayMapping('contractFacilityXref', 'Facilities', facilitiesArray, 'facilityId', { hideFromFilter: true, truncate: true,sortable: true  }),
        createStringDataField('ai', 'AI', { sortable: false }),
        createContractStateField('contractState.name', 'State', {
            secondLevel: 'name', sortable: true, equators: StringEquators, isStrictDropdown: true, hideFromFilter: true,
            dropdownValues: contractStates?.map(item => ({ label: item.name, value: item.name }))
        }),
    ]
);

const selectFilteredFields = createSelector(
    selectFields,
    (fields) => {
        return fields.map(field => field.id);
    }
);

const selectSort = createSelector(
    (state) => state.pages['contractsv2-landing'].sort,
    (sort) => sort || DEFAULT_SORT,
);



const selectFilteredData = createSelector(
    selectContracts,
    (data) => {
        return data
    }
);

const selectContractScs = createSelector(
    selectContracts,
    (data) => {
        return data?.contracts ?? []
    }
);

const selectDirectories = createSelector(
    selectContracts,
    (data) => {
        return data?.directories ?? []
    }
);

const filteredContracts = createFilteredSortedDataSelector(
    selectFilteredFields,
    (state) => state.pages[`contractsv2-landing`].filter,
    selectSort,
    selectContractScs,
);

const filteredDirectories = createFilteredSortedDataSelector(
    selectFilteredFields,
    (state) => state.pages[`contractsv2-landing`].filter,
    selectSort,
    selectDirectories,
);

import {
    Badge,
    Box, Button, Chip, Dialog, DialogActions, DialogContent,
    DialogContentText, DialogTitle, Divider, Grid,
    IconButton, MenuItem, Stack, Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow, TextField, Tooltip
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React, { useEffect, useMemo, useRef, useState } from "react";
import Helmet from 'react-helmet';
import { Loadable, TableLevelAction, useGlobalStore } from '../../common';

import { Delete as DeleteIcon, Edit as EditIcon } from '@mui/icons-material';
import CopyIcon from '@mui/icons-material/FileCopy';

import ReorderIcon from "@mui/icons-material/DragIndicator";
import PageviewIcon from '@mui/icons-material/Pageview';
import { useData, useInterval, useStatePtr } from '@pure-ptr/react';
import HeaderColumn from "../../common/dataTable/HeaderColumn";
import { RowCheckbox } from "../../common/dataTable/rowCheckbox";
import { EllipsisMenu } from '../../common/EllipsisMenu';
import {
    Portlet,
    PortletBody,
    PortletHeader,
    PortletHeaderToolbar
} from "../../partials/content/Portlet";
import { ROLE_ADMIN, ROLE_PARTNER_ADMIN, ROLE_SUPERADMIN } from "../../store/constants/roles";
import { asDate } from '../../util/date';
import { ContractsBreadCrumb } from "./ContractsBreadCrumb";
import { ContractsDraggable } from "./ContractsDraggable";
import { ContractsDroppable } from "./ContractsDroppable";
import { ContractsSearchComponent } from './ContractsSearchComponent';
import { ContractStateDialog } from './ContractStateDialog';
import { ContractsTopFilter } from './ContractsTopFilter.js';
import { CopyContractDialog } from './CopyContractDialog';
import { DependencyDialog } from "./DependencyDialog";
import { DirectoryDependencyDialog } from "./DirectoryDependencyDialog";
import { DirectoryEditDialog } from "./DirectoryEditDialog";
import { MoveItemsDialog } from "./moveItemsDialog";

import ChatIcon from '@mui/icons-material/Chat';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import HistoryIcon from '@mui/icons-material/History';
import NoteAddIcon from '@mui/icons-material/NoteAdd';

const useStyles = makeStyles(theme => {
    return {
        root: {
            display: 'flex',
            overflowX: 'auto',
            flexDirection: 'column',
        },
        container: {
            flexGrow: 1,
        },
        textField: {
            width: 400,
        },
        portlet: {
            display: 'flex',
            flexGrow: 1,
        },
        tr: {
            "& th": {
                padding: '6px 24px 6px 16px',
                top: "0px",
                '@media (max-width: 1440px)': {
                    padding: "6px 5px 6px 5px"
                },
                '@media (max-width: 1280px)': {
                    padding: "3px 5px 3px 5px"
                },
                '@media (max-width: 1024px)': {
                    top: '0px',
                    padding: "6px 5px 6px 5px"
                },
                '@media (max-width: 830px)': {
                    top: '0px!important'
                },
                '@media screen and (max-width: 1279px) and (min-width: 1025px)': {
                    top: '0px!important'
                },
            },
        },
        trBody: {
            "& td": {
                '@media (max-width: 1440px)': {
                    padding: "6px 5px 6px 5px"
                },
                '@media (max-width: 1280px)': {
                    padding: "3px 5px 3px 5px"
                },
                '@media (max-width: 1024px)': {
                    padding: "6px 5px 6px 5px"
                }
            },
        },
        folderDiv: {
            cursor: 'pointer',
            textDecoration: 'underline'
        },
        searchIcon: {
            position: 'relative',
            bottom: '8px'
        },
        button: {
            marginTop: theme.spacing(3),
            marginBottom: theme.spacing(1),
            marginRight: theme.spacing(1),
            padding: '0.25rem',
        },
        banIcon: {
            fontSize: 17
        },
        dimmedOpacity:{
            opacity:0.5
        }
    }
});

import UploadFileIcon from '@mui/icons-material/UploadFile';
import { AiChatDialog } from "./AiChatPage";
import { useAiSetting } from "./common";
import { DocumentUpload } from "./DocumentUpload";
import { MODULE_TYPE_CONTRACT } from "../../store/constants/contract";
import { ContractInfo, contractInfoEndpoint } from "../../store/api/ai-api";
import SvgIcon from "../../svg/SvgIcon";
import { ChatSidebarWrapper } from "./ChatSidebarWrapper";


function ContractsPageV2Component({
    intl,
    history, directoryId, defaultContractState, contracts, directories, sort, getListPending, deletePending, userRole, movePending,
    actions: { setSort, getContractsList, resetContracts,
        setDirectoryEditDialog, setMoveDialog, resetSelected, setContractsV2DirectoryDependencyDialog, getHierarchy, getFacilities, deleteReset, setCopyContractDialog, setContractDependencyDialog, setStateDialog, deleteClaimByContractId, getStates }
}) {
    const dispatch = useDispatch();
    const enableAi = useAiSetting();
    const classes = useStyles();

    const contractStates = useGlobalStore(state => state.contracts.states);
    const facilitiesArray = useGlobalStore(state => state.facilities.data);
    const clientHaveAIAccess = useSelector<RootState>((state) => state.clients.hasAIAccess)

    const fields = useMemo(() => [
        createStringDataField('name', 'Contract Name', { sortable: true }),
        createPlainDateField('effectiveDate', 'Effective Date', { fieldType: 'Date', sortable: true }),
        createPlainDateField('terminationDate', 'Termination Date', { fieldType: 'Date' , sortable: true}),
        createDateField('finalizedDate', 'Finalized Date', { fieldType: 'Date', sortable: true }),
        createStringFieldFromArrayMapping('contractFacilityXref', 'Facilities', facilitiesArray, 'facilityId', { hideFromFilter: true, truncate: true}),
       ...(clientHaveAIAccess ? [ createStringDataField('ai', 'AI', { sortable: false })]:[]),
        createContractStateField('contractState.name', 'State', {
            secondLevel: 'name', sortable: true, equators: StringEquators, isStrictDropdown: true, hideFromFilter: true,
            dropdownValues: contractStates?.map(item => ({ label: item.name, value: item.name }))
        }),
    ], [contractStates, facilitiesArray]);

    const { id: columnOrder, direction } = (sort && sort.length > 0 && sort[0]) || {};
    const [anchorEl, setAnchorEl] = useState(null);
    const [isClaimConfirmOpen, setClaimConfimOpen] = useState(false);
    const [existingContractId, setExistingContractId] = useState(null);

    // Sidebar state (no routing - pure state management)
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [sidebarExpanded, setSidebarExpanded] = useState(false);
    const [sidebarData, setSidebarData] = useState<{
        contractId: number;
        sessionId: number;
        directoryId: string;
        selected?: any[];
    } | null>(null);

    useEffect(() => {
        getHierarchy();
    }, [getHierarchy]);

    useEffect(() => {
        getFacilities()
    }, [getFacilities]);

    const contractsInfoPtr = useStatePtr([]),
        contractsInfo = contractsInfoPtr.value;

    const ContractsApi = new ContractInfo()
    const clientId = useSelector<RootState>((state) => state.dashboards.selectedClient)

    // Fetch Contract info
    const { reload: refreshContractInfo } = useData(async abort => {
        if(!clientHaveAIAccess) return;
        contractsInfoPtr.set(
            await contractInfoEndpoint.find(undefined, abort)
        );
    }, []);


    const { reload, data: credits } = useData(async abort => {

       const credits = await getEAPGCreditUsage("ai")
        return credits

    }, [clientId]);


    const canUseAI = () => {
        const aiCredits = credits || {}
        return aiCredits?.totalLimit && aiCredits?.usedCredits < aiCredits?.totalLimit
    }

    const haveAIAccess = canUseAI() && clientHaveAIAccess


    // Refresh contract Info for every 15 seconds
    useInterval(refreshContractInfo, 30000);

    const contractsWithInfo = useMemo(() =>
        contracts.map(contract => ({
            ...contract,
            info: contractsInfo?.find(i => i.id === contract.id) ?? ContractInfo.object({ id: contract.id })
        }))
        , [contracts, contractsInfo, sort]);

    useEffect(() => {
        getContractsList(directoryId, defaultContractState === "all" ? '' : defaultContractState || 'finalized');
        return () => {
            resetContracts();
        }
    }, [directoryId]);

    useEffect(() => {
        getStates();
    }, [getStates]);

    const handleRedirectToDirectory = (directoryId) => {
        resetSelected();
        history.push(`/cms/contracts/${directoryId}`);
    }

    const handleView = (rowData) => {
        history.push(`/cms/contract/view/${rowData?.id}/${directoryId}`);
    }
    const handleEdit = (rowData) => {
        history.push(`/cms/contract/edit/${rowData.id || 'new'}/${directoryId}`);
    }

    function handleRefresh(contractState = defaultContractState) {
        getContractsList(directoryId, contractState === "all" ? '' : contractState || "finalized");
        getHierarchy();
    }

    const handleCloseAddMenu = () => {
        setAnchorEl(null);
    };

    const handleAddFolder = () => {
        setDirectoryEditDialog({ open: true, mode: 'create', parentId: directoryId });
        handleCloseAddMenu();
    }

    const handleEditFolder = ({ id, name }) => {
        setDirectoryEditDialog({ open: true, mode: 'edit', parentId: directoryId, id, name });
    }

    const handleFolderDeleteDependencies = ({ id, name }) => {
        setContractsV2DirectoryDependencyDialog({ open: true, directoryId: id, directoryName: name })
    }


    const handleMoveFiles = () => {
        setMoveDialog({ open: true });
    }
    const handleSearchClick = (rowData, directoryId) => {
        history.push(`/cms/contract/view/${rowData?.id}/${directoryId}`);
    }

    const totalContracts = useGlobalStore(x => x.contractsv2.contracts.totalCount);

    const selected = useGlobalStore( x => {
        const ids = x.pagesV2['contractsv2-landing']?.selected?.map( s => Number( s?.match(/-(.*)$/) ? s?.match(/-(.*)$/)[1]:null ));
        return ids? contracts.filter( c => ids.includes( c.id ) ):[];
    });

    const selectedWithNoDocs = selected?.filter(
        selectedContract =>
            [...(contractsWithInfo || [])]?.find(item => {
                if (item?.id == selectedContract?.id) {
                    return item;
                }
            })?.info?.processedDocsCount <= 0
    );

    const dialogPtr = useStatePtr(null);

    const openDocUploadForContractDialog = useStatePtr(null);

    const tableLevelActions = () => {
        return (
            <>
                <Grid item>
                    <IconButton
                        sx={iconButtonStyle}
                        onClick={handleEdit}
                    >
                        <Tooltip title="Add Contract">
                            <NoteAddIcon />
                        </Tooltip>
                    </IconButton>

                    <IconButton
                        sx={iconButtonStyle}
                        onClick={handleAddFolder}
                    >
                        <Tooltip title="Add Folder">
                            <CreateNewFolderIcon />
                        </Tooltip>
                    </IconButton>
                </Grid>

                <Grid item className={`${classes.searchIcon}`}>
                    <ContractsSearchComponent
                        handleSetContract={handleSearchClick}
                    />
                </Grid>

                <Grid item>
                 {haveAIAccess ?   <Tooltip title={selectedWithNoDocs?.length>0 ?"Some selected contracts have no documents.":"SlicedIQ Insights"} ><IconButton
                        sx={{...iconButtonStyle,color:selectedWithNoDocs?.length>0 && "rgba(0, 0, 0, 0.26)"}}
                        onClick={() => {
                            if (selectedWithNoDocs?.length===0 || !selectedWithNoDocs) {
                                setSidebarData({
                                    contractId: 0, // multi-contract
                                    sessionId: 0,
                                    directoryId: directoryId,
                                    selected: selected
                                });
                                setSidebarOpen(true);
                            }
                        }}
                        disabled={selected?.length<2}
                        style={{
                            filter: selected?.length<2 ? 'grayscale(1)' : 'none',
                        }}
                    >
                        
                            <SvgIcon className='chat-icon' id='chat-icon'  width="19" height="19"  />
                        
                    </IconButton></Tooltip>:<></>}


                    <IconButton
                        sx={iconButtonStyle}
                        aria-label="Edit"
                        onClick={handleMoveFiles}
                    >
                        <Tooltip title="Move Contracts">
                            <i className="fas fa-file-import"></i>
                        </Tooltip>
                    </IconButton>
                </Grid>
            </>
        );
    }

    const handleSort = ({ id, direction, fieldType }) => {
        if (!setSort) {
            return;
        }

        const sorts = [...sort];
        const updatedSort = { id, fieldType, direction, orderBy: direction };
        const oldSort = sorts.find((sort) => {
            return sort.id === id;
        });

        // sort exists, toggle sort
        if (oldSort && oldSort.id === id) {
            const index = sorts.indexOf(oldSort);
            updatedSort.direction = oldSort.direction === 'asc' ? 'desc' : 'asc';
            updatedSort.orderBy = updatedSort.direction;
            sorts[index] = updatedSort;
        }
        // new sort
        else {
            updatedSort.direction = 'desc';
            updatedSort.orderBy = updatedSort.direction;
            sorts.splice(0, sorts.length);
            sorts.push(updatedSort);
        }

        setSort(sorts);
    }

    function handleCopyContract(contractObj) {
        deleteReset();
        setCopyContractDialog({
            open: true,
            existingContractId: contractObj.id,
            existingContractName: contractObj.name,
            existingContractStateId: contractObj.contractStateId
        });
    }

    const handleDeleteConfirmation = (rowData) => {
        setContractDependencyDialog({
            open: true,
            contractId: rowData.id,
            contractName: rowData.name
        })
    }
    const handleClaimOpen = (rowData) => {
        setClaimConfimOpen(true);
        setExistingContractId(rowData.id)
    }
    const handleChangeState = (rowData) => {
        setStateDialog({
            open: true,
            contractId: rowData.id,
            contractStateId: rowData.contractState.id
        });
    }
    const handleStateDialogClose = (shouldRefresh) => {
        setStateDialog(null);
        if (shouldRefresh) {
            handleRefresh();
        }
    }
    const handleClaimClose = () => {
        setClaimConfimOpen(false);
    }

    const handleAnalysisDelete = () => {
        handleClaimClose();
        deleteClaimByContractId(existingContractId, handleAnalysisDeleteCallback);
    }

    const handleAnalysisDeleteCallback = () => {
        setExistingContractId(null);
    }

    const ContractHierarchyActions = ({ rowData }) => {
        return (
            (<div className="d-flex">
                <IconButton
                    color="primary"
                    className="p-1"
                    aria-label="Edit"
                    onClick={() => handleView(rowData)}
                    size="large">
                    <Tooltip title="View">
                        <PageviewIcon />
                    </Tooltip>
                </IconButton>
                <IconButton
                    color="primary"
                    className="p-1"
                    aria-label="Edit"
                    onClick={() => handleEdit(rowData)}
                    size="large">
                    <Tooltip title="Edit">
                        <EditIcon />
                    </Tooltip>
                </IconButton>
                <div>
                    <EllipsisMenu
                        renderMenuItems={[
                            <MenuItem
                                className="justify-content-center"
                                onClick={() => handleCopyContract(rowData)}
                            >
                                <IconButton color="primary" className="p-1" aria-label="Copy" size="large">
                                    <Tooltip title={`Copy Contract`}>
                                        <CopyIcon />
                                    </Tooltip>
                                </IconButton>
                            </MenuItem>,
                            <Divider />,
                            <MenuItem
                                className="justify-content-center px-0"
                                onClick={() =>
                                    handleDeleteConfirmation(rowData)
                                }
                            >
                                <IconButton
                                    color={"primary"}
                                    className={classes.button}
                                    aria-label="Delete"
                                    size="large">
                                    <Tooltip title={"Delete Contract"}>
                                        <DeleteIcon />
                                    </Tooltip>
                                </IconButton>
                            </MenuItem>,
                            <Divider />,
                            <MenuItem
                                onClick={() => handleClaimOpen(rowData)}
                                className="justify-content-center px-0"
                            >
                                <IconButton color="primary" className="p-1" size="large">
                                    <Tooltip title={"Delete Analysis"}>
                                        <i
                                            className={`${classes.banIcon} fas fa-ban`}
                                        ></i>
                                    </Tooltip>
                                </IconButton>
                            </MenuItem>,
                            <Divider />,
                            <MenuItem
                                onClick={() => handleChangeState(rowData)}
                                className="justify-content-center px-0"
                            >
                                <IconButton color="primary" className="p-1" size="large">
                                    <Tooltip title={"Change Contract State"}>
                                        <i
                                            className={`${classes.banIcon} fas fa-exchange-alt`}
                                        ></i>
                                    </Tooltip>
                                </IconButton>
                            </MenuItem>,
                        ]}
                    />
                </div>
            </div>)
        );
    }

    if (dialogPtr.value === "ai-chat") {
        return (
            <>
                <ContractsBreadCrumb
                    root="/cms/contracts"
                    directoryId={directoryId}
                    handleRefresh={handleRefresh}
                />
                <AiChatDialog
                    selected={selected}
                    onClose={() => dialogPtr.set(null)}
                />
            </>
        );
    }


    return (<>
        <ContractsBreadCrumb root="/cms/contracts" directoryId={directoryId} handleRefresh={handleRefresh} />
        
        {/* Main content wrapper with sidebar */}
        <Box sx={{ 
            display: 'flex', 
            flexDirection: 'row', 
            width: '100%', 
            height: sidebarOpen ? 'calc(100vh - 180px)' : 'auto',
            alignItems: 'flex-start',
            gap: 0,
            overflow: sidebarOpen ? 'hidden' : 'visible',
        }}>
            {/* Main content area */}
            <Box sx={{ 
                flex: sidebarExpanded ? 0 : 1,
                minWidth: 0,
                height: sidebarOpen ? '100%' : 'auto',
                opacity: sidebarExpanded ? 0 : 1,
                width: sidebarExpanded ? 0 : 'auto',
                overflow: sidebarExpanded ? 'hidden' : (sidebarOpen ? 'auto' : 'visible'),
                transition: 'all 0.3s ease-in-out',
            }}>
                <Loadable loading={getListPending || deletePending || movePending }>
                    <Helmet title="Contracts" />
                    <Portlet className={classes.root}>
                        <PortletHeader
                            title="Contracts"
                            toolbar={<PortletHeaderToolbar>
                                <ContractsTopFilter handleRefresh={handleRefresh} />
                            </PortletHeaderToolbar>}
                        />
                        <PortletBody>

                    <Grid spacing={1} container>
                        <Grid item xs={12}>
                            <TableLevelAction
                                handleRefresh={() => handleRefresh(defaultContractState)}
                                actions={tableLevelActions}
                                name={''}
                                loading={false}
                                actionLevelGrid={() =>
                                    <Box display='flex' justifyContent='space-between' width='100%'>
                                        Total Contracts: {totalContracts}
                                    </Box>
                                }
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Table stickyHeader={true}>
                                <TableHead>
                                    <TableRow className={`${classes.tr} fee-schedule-thr`}>
                                        <TableCell className="drag-cell"></TableCell>
                                        {fields.map((field: Field, index) => (
                                            !field?.options.hideFromGrid && <HeaderColumn
                                                key={`column-${index}`}
                                                field={field}
                                                onSort={handleSort}
                                                direction={direction}
                                                columnOrder={columnOrder}
                                            />
                                        ))
                                        }
                                        <HeaderColumn field={{ label: 'Actions' }} />
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {directories?.length === 0 && contractsWithInfo?.length === 0 &&
                                        <TableRow>
                                            <TableCell></TableCell>
                                            <TableCell colSpan={5}>No records found!</TableCell>
                                        </TableRow>
                                    }
                                    {directories?.map(item => {
                                        return (
                                            <ContractsDroppable key={item} item={item} classes={classes} handleRefresh={handleRefresh}>
                                                <TableCell id={`folder-${item.id}`} className="drag-cell">
                                                    <IconButton
                                                        id={`folder-${item.id}`}
                                                        className='fee-schedule-rerder-button'
                                                        size="large"><ReorderIcon />
                                                    </IconButton>
                                                    <RowCheckbox rowDataId={`folder-${item.id}`} pageName={'contractsv2-landing'} customClasses='p-1' />
                                                </TableCell >
                                                <TableCell id={`folder-${item.id}`} colSpan={4}>
                                                    <div id={`folder-${item.id}`} className={classes.folderDiv} onClick={() => handleRedirectToDirectory(item.id)}>
                                                        <IconButton id={`folder-${item.id}`} className="p-1 mr-2" size="large">
                                                            <Badge badgeContent={item.count} color="primary">
                                                                <i id={`folder-${item.id}`} style={{ color: '#FFCA35' }} className="fas fa-folder"></i>
                                                            </Badge>
                                                        </IconButton>
                                                        {item.name}
                                                    </div>
                                                </TableCell>
                                                <TableCell></TableCell>
                                                <TableCell></TableCell>

                                               {clientHaveAIAccess && <TableCell></TableCell>}

                                                <TableCell className="pl-3">
                                                    <IconButton color="primary" className='p-1 invisible' aria-label="Edit" size="large">
                                                        <Tooltip title="View">
                                                            <PageviewIcon />
                                                        </Tooltip>
                                                    </IconButton>
                                                    <IconButton
                                                        color="primary"
                                                        className='p-1'
                                                        aria-label="Edit"
                                                        onClick={() => handleEditFolder(item)}
                                                        size="large">
                                                        <Tooltip title="Edit">
                                                            <EditIcon />
                                                        </Tooltip>
                                                    </IconButton>
                                                    {(userRole === ROLE_SUPERADMIN || userRole === ROLE_ADMIN || userRole === ROLE_PARTNER_ADMIN) &&
                                                        <IconButton
                                                            onClick={() => handleFolderDeleteDependencies(item)}
                                                            color={"primary"}
                                                            className='p-1'
                                                            aria-label="Delete"
                                                            size="large">
                                                            <Tooltip title={"Delete Folder"} >
                                                                <DeleteIcon />
                                                            </Tooltip>
                                                        </IconButton>}
                                                </TableCell>
                                            </ContractsDroppable>
                                        );
                                    })}
                                    {contractsWithInfo?.map((item, idx) => {
                                        return (
                                            <ContractsDraggable classes={classes} item={item}>


                                                <TableCell className="drag-cell">
                                                    <div className="d-flex">
                                                        <IconButton className='fee-schedule-rerder-button' size="large">
                                                            <ReorderIcon />
                                                        </IconButton>
                                                        <RowCheckbox rowDataId={`contracts-${item.id}`} pageName={'contractsv2-landing'} customClasses='p-1' />
                                                    </div>
                                                </TableCell>
                                                <TableCell className="pl-4">{item.name}</TableCell>
                                                <TableCell>{asDate(item.effectiveDate) || 'N/A'}</TableCell>
                                                <TableCell>{asDate(item.terminationDate) || 'N/A'}</TableCell>
                                                <TableCell>{asDate(item.finalizedDate, 'date-time') || 'N/A'}</TableCell>
                                                <TableCell>{fields[4]?.renderString(item?.contractFacilityXref)}</TableCell>

                                {clientHaveAIAccess && (
                                                    <TableCell>
                                                            

                                                            {/* Upload Icon & Chat & History section */}
                                                            <Box display="flex" gap={0.5}>
                                                                {/* Always show Upload Icon */}
                                                                <Tooltip
                                                                    title={!haveAIAccess ? mockCreditsMessage : "Upload Document"}
                                                                >
                                                                    <IconButton
                                                                        size="small"
                                                                        className={!haveAIAccess && classes.dimmedOpacity}
                                                                        onClick={() =>
                                                                            haveAIAccess && openDocUploadForContractDialog.set(item)
                                                                        }
                                                                    >
                                                                        <Badge
                                                                            variant="dot"
                                                                            color="error"
                                                                            invisible={!item?.info?.failedDocsCount || item?.info?.failedDocsCount === 0}
                                                                        >
                                                                            <UploadFileIcon />
                                                                        </Badge>
                                                                    </IconButton>
                                                                </Tooltip>
                                                                {/* Chat Icon */}
                                                                {selected?.length <= 0 && item?.info?.processedDocsCount > 0 && (
                                                                    <Tooltip title="SlicedIQ Insights">
                                                                        <IconButton
                                                                            size="small"
                                                                            onClick={() => {
                                                                                setSidebarData({
                                                                                    contractId: item.id,
                                                                                    sessionId: 0,
                                                                                    directoryId: directoryId
                                                                                });
                                                                                setSidebarOpen(true);
                                                                            }}
                                                                        >
                                                                            <SvgIcon
                                                                                className="chat-icon"
                                                                                id="chat-icon"
                                                                                width="19"
                                                                                height="19"
                                                                            />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                )}

                                                                {/* History Icon */}
                                                                {item?.info?.processedDocsCount > 0 && item?.info?.lastChatSessionId != null && item?.info?.lastChatSessionId > 0 && (
                                                                    <Tooltip title="History">
                                                                        <IconButton
                                                                            size="small"
                                                                            onClick={() => {
                                                                                history.push(
                                                                                    `/cms/contract/ai-chats-history/${item.id}/${directoryId}`
                                                                                );
                                                                            }}
                                                                        >
                                                                            <HistoryIcon />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                )}
                                                            </Box>
                                                        </TableCell>


                                                )}
                                                <TableCell>{fields[!clientHaveAIAccess ?5:6]?.renderString(item?.contractState?.name)}</TableCell>
                                                <TableCell><ContractHierarchyActions rowData={item} /> </TableCell>


                                            </ContractsDraggable>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </Grid>

                    </Grid>
                </PortletBody>
            </Portlet>
        </Loadable>
            </Box>

            {/* Chat Sidebar */}
            {sidebarOpen && sidebarData && (
                <ChatSidebarWrapper 
                    open={sidebarOpen}
                    onClose={() => {
                        setSidebarOpen(false);
                        setSidebarExpanded(false);
                        setSidebarData(null);
                    }}
                    contractId={sidebarData.contractId}
                    sessionId={sidebarData.sessionId}
                    directoryId={sidebarData.directoryId}
                    selected={sidebarData.selected || EMPTY_ARRAY}
                    chatType="contract"
                    isExpanded={sidebarExpanded}
                    onExpandToggle={() => setSidebarExpanded(prev => !prev)}
                />
            )}
        </Box>

        {/* Dialogs */}
        <DependencyDialog handleRefresh={handleRefresh} isContractDependencies={true} />
        <DirectoryDependencyDialog handleRefresh={handleRefresh} isContractDependencies={true} />
        <DirectoryEditDialog handleRefresh={handleRefresh} />
        <MoveItemsDialog handleRefresh={handleRefresh} />
        <CopyContractDialog
            handleRefresh={handleRefresh}
        />
        <ContractStateDialog handleClose={handleStateDialogClose} />
        {/* <DependencyDialog handleRefresh={handleRefresh} /> */}
        <Dialog open={isClaimConfirmOpen} onClose={handleClaimClose}>
            <DialogTitle>
                Delete
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Are you sure you want to delete Analysis of this contract?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClaimClose}>
                    Cancel
                </Button>
                <Button
                    onClick={handleAnalysisDelete}
                    color="primary">
                    Delete
                </Button>
            </DialogActions>
        </Dialog>

        {openDocUploadForContractDialog.value ?
            <Dialog
                open={true}
                onClose={() => openDocUploadForContractDialog.set(null)}
                fullWidth
                maxWidth="md"
            >
                <DocumentUpload
                    contract={openDocUploadForContractDialog.value}
                    handleUploadCallback={(callback, id) => {
                        dispatch(
                            getDocumentList(openDocUploadForContractDialog.value.id, (docData) => callback({ id: id?.id, docData }))
                        );

                        // Refresh to update the icon.
                        refreshContractInfo();
                    }}
                    module={MODULE_TYPE_CONTRACT}
                    shouldDeleteDocument={true}
                />

                <DialogActions>
                    <Button onClick={() => openDocUploadForContractDialog.set(null)} variant="outlined" color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
            : null}
    </>);
}

const iconButtonStyle = {
    position: 'relative',
    top: '-5px'
}

export const AiContractsPageV2 = connect(
    () => {
        return (state: any, props) => ({
            getListPending: state.contractsv2.getContracts.pending,
            movePending: state.contractsv2.move.pending,
            filteredData: selectFilteredData(state as never),
            // contracts:state.contractsv2.contracts?.contracts,
            contracts: filteredContracts(state),

            // directories: state.contractsv2.contracts?.directories,
            directories: filteredDirectories(state),

            order: state.pages['contractsv2-landing'].order,
            filter: state.pages['contractsv2-landing'].filter,
            defaultContractState: state?.pagesV2['contractsv2-landing'].contractState,
            sort: selectSort(state),
            userRole: selectSessionRole(state),
            directoryId: selectDirectoryId(state, props)
        });
    },
    (dispatch) => ({
        actions: bindActionCreators({
            setOrder: (value) => set('contractsv2-landing', 'order', value),
            setSort: (value) => set('contractsv2-landing', 'sort', value),
            resetSelected: () => setV2('contractsv2-landing', 'selected', []),
            getContractsList: getContractsV2,
            resetContracts: resetContracts,
            setDirectoryEditDialog: setDirectoryEditDialog,
            setMoveDialog: setMoveDialog,
            setContractsV2DirectoryDependencyDialog,
            getHierarchy: getHierarchy,
            getFacilities,
            deleteReset,
            setCopyContractDialog,
            setContractDependencyDialog,
            deleteClaimByContractId,
            setStateDialog,
            getStates
        }, dispatch)
    })
)(injectIntl(ContractsPageV2Component));